import { render, staticRenderFns } from "./ModalList.vue?vue&type=template&id=23563d4c&scoped=true&"
import script from "./ModalList.vue?vue&type=script&lang=js&"
export * from "./ModalList.vue?vue&type=script&lang=js&"
import style0 from "./ModalList.vue?vue&type=style&index=0&id=23563d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23563d4c",
  null
  
)

export default component.exports